import { Link } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth, isProduction } from '../firebase';
import { useAuth } from '../contexts/AuthContext';
import { AppPreviewToggle } from './AppPreviewPanel';
import { usePreview } from '../contexts/PreviewContext';

const ROLE_LABELS = {
  GlobalAdmin: 'Global Admin',
  ClubAdmin: 'Club Admin Portal',
  RaceOfficer: 'Race Officer Portal',
};

export default function PortalHeader() {
  const { user, portalRole, isGlobalAdmin } = useAuth();
  const { isOpen, toggle } = usePreview();
  const roleLabel = ROLE_LABELS[portalRole?.role] || 'Committee Portal';

  return (
    <header className="portal-top-bar">
      <div className="portal-top-left">
        <span className="portal-role-label">{roleLabel}</span>
        <span className="portal-chevron">&raquo;</span>
        <Link to="/" className="portal-brand">
          <img src={isProduction ? '/logo.png' : '/logo-staging.png'} alt="Race Marks" className="portal-logo" />
          <span className="portal-title">
            <strong>Race Marks</strong>{' '}
            <span className="portal-edition">Committee Edition</span>
          </span>
        </Link>
      </div>
      <div className="portal-top-right">
        <Link to="/changelog" style={{ fontSize: '0.85rem', color: '#8ab4f8', textDecoration: 'none', marginRight: '0.5rem' }}>
          What's New
        </Link>
        {isGlobalAdmin && (
          <AppPreviewToggle isOpen={isOpen} onToggle={toggle} />
        )}
        <span className="portal-email">{user.email}</span>
        <span className="role-badge">{portalRole?.role}</span>
        <button className="btn btn-sm" onClick={() => signOut(auth)}>
          Sign out
        </button>
      </div>
    </header>
  );
}
